// extracted by mini-css-extract-plugin
export default {"thresholdValueCard":"_3rU7BGqx6ZKOD-kYLjx8U-"};